import { render, staticRenderFns } from "./CustomFieldDate.vue?vue&type=template&id=60ba0074"
import script from "./CustomFieldDate.vue?vue&type=script&lang=js"
export * from "./CustomFieldDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports